import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot, getDoc } from "firebase/firestore";
import { auth, db } from '../config/firebaseConfig';

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let unsubscribeSnapshot = null;

        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);

            if (user) {
                const userDocRef = doc(db, 'users', user.uid);
                
                unsubscribeSnapshot = onSnapshot(
                    userDocRef, 
                    async (document) => {
                        if (document.exists()) {
                            const basicUserData = document.data();
                            let permissions = {};

                            if (basicUserData.role && basicUserData.role !== 'admin') {
                                try {
                                    const roleDocRef = doc(db, 'rolePermissions', basicUserData.role);
                                    const roleDocSnap = await getDoc(roleDocRef);
                                    if (roleDocSnap.exists()) {
                                        permissions = roleDocSnap.data().allowedModules || {};
                                    }
                                } catch (err) {
                                    console.error("Error fetching permissions:", err);
                                }
                            }

                            setUserData({ uid: document.id, ...basicUserData, permissions });
                        } else {
                            console.error("Firestore document for user not found!");
                            setUserData(null);
                        }
                        setLoading(false);
                    },
                    (error) => {
                        console.error("Firestore data fetch error:", error);
                        setUserData(null);
                        setLoading(false);
                    }
                );
            } else {
                setUserData(null);
                setLoading(false);
                if (unsubscribeSnapshot) unsubscribeSnapshot();
            }
        });

        return () => {
            unsubscribeAuth();
            if (unsubscribeSnapshot) unsubscribeSnapshot();
        };
    }, []);

    const value = {
        currentUser,
        userData, 
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};